import Game from 'Game';
import { IAPDebugMode } from 'State/Game/IAPDebugMode';
import { IGameState } from 'State/Game/IGameState';

export async function hasProductBeenConsumed(state: IGameState, purchase: FBInstant.Purchase) {
    try {
        if (state.perSessionData.iapDebugMode === IAPDebugMode.ALWAYS_SUCCEED)
            return false;
        
        const unconsumedPurchases = await Game.sdk.getPurchases();
        return !unconsumedPurchases.some((purchaseData: FBInstant.Purchase) => {
            return purchase.purchaseToken === purchaseData.purchaseToken;
        });
    } catch (error) {}
}
